// Contract for the dev-only variants harness: studio declares enumerated UX/behavior
// axes, carries the chosen values in one URL param, and forwards them to forge in a
// request header. Values are 1-based ints and 1 is always the proposed default, so an
// absent key means "default". Encoding is keyed pairs — "chip:3,input:2" — with keys
// restricted to [a-z0-9-]+ so the key:value,key:value form never needs escaping.

export interface VariantOption {
	key: string;
	title: string;
	// labels[0] describes value 1 (the proposed default), labels[1] value 2, and so on
	labels: string[];
}

export const VARIANTS_PARAM = 'variants';
export const VARIANTS_HEADER = 'x-variants';

const PAIR = /^([a-z0-9-]+):(\d+)$/;

// Tolerant: malformed pairs are skipped, so a mangled shared link degrades to
// defaults instead of erroring.
export const parseVariants = (encoded: string): Record<string, number> => {
	const values: Record<string, number> = {};
	for (const pair of encoded.split(',')) {
		const match = PAIR.exec(pair.trim());
		if (match) {
			values[match[1]] = parseInt(match[2], 10);
		}
	}
	return values;
};

export const serializeVariants = (values: Record<string, number>): string =>
	Object.entries(values)
		.map(([key, value]) => `${key}:${value}`)
		.join(',');
